/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-09-20 18:04:38
 * @Description  : 根据需求配置常量
 */


import { constConf } from "@GLOBAL/constConf"
import { client } from '@UTILS/client';

const { PROJECT, FOLDER } = constConf
const { isOxygen, isOxygenPC } = client

const constant = {
  RELEASE: `${PROJECT}_${FOLDER}`,
  IS_APP: isOxygen,
  IS_PC: isOxygenPC,
}

export { constant }
